import React from 'react';
import 'twin.macro';

interface BoardMemberProps {
  title: string;
  name: string;
}

const BoardMember: React.FC<BoardMemberProps> = ({ title, name, children }) => (
  <div tw="flex flex-col items-center space-y-4 text-center">
    {children}
    <div>
      <p tw="font-bold text-lg text-blue-900">{name}</p>
      <p tw="text-blue-900">{title}</p>
    </div>
  </div>
);

export default BoardMember;
